import styled, {css} from 'styled-components';
import {NavigationStatusTextProps} from 'components/GuestsPanel/types';
import {device} from 'styled/device';
import {CustomIcon} from '@guestapp/ui';

export const StatusText = styled.div<NavigationStatusTextProps>`
  display: flex;
  width: 100%;
  font-style: normal;
  font-weight: ${props => props.theme.fonts.fontWeight.bold};
  font-size: ${props => props.theme.fonts.sizes.small};
  line-height: 24px;
  color: ${props => props.theme.colors.$p8};
  user-select: none;

  ${props =>
    props.$completed &&
    css`
      color: ${props => props.theme.colors.$s2};
    `}
`;

export const StatusIcon = styled.img`
  margin-right: 6px;
`;

export const Texts = styled.div`
  display: block;
`;

export const Title = styled.div`
  display: block;
  width: 100%;
  font-weight: ${props => props.theme.fonts.fontWeight.bold};
  font-size: ${props => props.theme.fonts.sizes.medium};
  line-height: 24px;
  color: ${props => props.theme.colors.branding.fontPrimary};

  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DotsButton = styled(CustomIcon)`
  circle {
    fill: ${({theme}) =>
      theme.hasTemplate
        ? theme.colors.branding.primary
        : theme.colors.buttons.mainButtonBackground};
  }
`;

export const EmptyBox = styled.div`
  display: flex;
  min-height: 80px;
  cursor: pointer;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.backgroundSecondary : '#eaecef'};

  &:hover {
    background-color: rgba(56, 91, 248, 0.1);
    transition: background-color 0.05s ease-in-out;
  }

  @media (min-width: ${device.tablet}) {
    width: 100%;
  }

  @media (min-width: ${device.laptopM}) {
    max-width: 416px;
  }
`;

export const EmptyBoxTitle = styled.div`
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.fontSecondary : '#777e91'};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const ButtonBox = styled(CustomIcon).attrs({className: 'guests-panel__add-btn'})`
  path {
    stroke: ${({theme}) =>
      theme.hasTemplate ? theme.colors.branding.boxesModals : '#fff'};
  }
`;
